"use client"

import { BluredOverlay } from "@/app/components/blured-overlay"
import { cn } from "@rarible_int/anaconda_ui_components"

interface Props {
  className?: string
  children?: React.ReactNode
  style?: React.CSSProperties
  brandTheme?: {
    backgroundColor: string
    textColor: string
  }
}

/**
 * ToolbarContainer created as a separate component to be able to use client-side "cn" util
 * It helps to add className composition instead of creating separate wrappers
 */

export function ToolbarContainer({
  className,
  children,
  style,
  brandTheme,
}: Props) {
  return (
    <BluredOverlay
      className={cn(
        "toolbar-container sticky bottom-0 z-40 md:pb-4",
        className,
      )}
      style={style}
      brandTheme={brandTheme}
    >
      {children}
    </BluredOverlay>
  )
}
